import React from "react";

import { MainTabSection } from "./index.styles";
import { SpinnerLoader } from "../loaders";
import { withShowIf } from "../with-show-if/with-show-If.component";

export const BriefLoader = withShowIf(() => (
  <MainTabSection>
    <SpinnerLoader />
  </MainTabSection>
));
